import { render, staticRenderFns } from "./BacktestBollinger.vue?vue&type=template&id=d1720fc4&scoped=true"
import script from "./BacktestBollinger.vue?vue&type=script&lang=js"
export * from "./BacktestBollinger.vue?vue&type=script&lang=js"
import style0 from "./BacktestBollinger.vue?vue&type=style&index=0&id=d1720fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1720fc4",
  null
  
)

export default component.exports